import { FC } from 'react';

import StatusDot from '@components/StatusDot/StatusDot';
import useAdminSupplementInquiryStatusById from '@store/hooks/useAdminSupplementInquiryStatusById';

import { IAdminSupplementStatusDotProps } from './AdminSupplementStatusDot.interface';
import { getStatusIcon } from './utils';

const AdminSupplementStatusDot: FC<IAdminSupplementStatusDotProps> = ({ className, value }) => {
  const adminSupplementStatus = useAdminSupplementInquiryStatusById(value);

  if (!adminSupplementStatus) return null;

  return (
    <StatusDot
      className={className}
      icon={getStatusIcon(value)}
      title={adminSupplementStatus.name}
      small
    />
  );
};

export default AdminSupplementStatusDot;
